// Module
var code = "<span class=\"hbox cross-center\"> <div class=\"iconized-name-icon\" ng-style=\"{background: $ctrl.bgColor || '#87739B'}\"> {{$ctrl.content}} </div> <p class=\"iconized-name ellipsis\">{{$ctrl.name}}</p> </span> ";
// Exports
module.exports = code;